

















import { Vue, Component, PropSync } from "vue-property-decorator";

@Component({ components: {} })
export default class CalendarCard extends Vue {
  @PropSync("showDialog")
  private dialog!: boolean;

  private doNotShowAgain: boolean = false;

  private cardText: string =
    "You have selected a special leadership role. In a leadership role, the fun and enjoyment " +
    "of other players will be greatly affected by the way you act. Your highest goal should be to make sure players " +
    "are having a great time within the event. Please make sure you are completely familiar with our event rules and " +
    "make extra sure you can play on the event day. Check out this guide on how to be a better squad leader:";

  private leadershipUrl: string = `https://arma.npcs.games/guide/general/how-to-be-a-good-leader-in-arma/`;

  private submit() {
    if (this.doNotShowAgain) {
      localStorage.setItem("leadershipDialogDisabled", "true");
    }
    this.dialog = false;
    this.$emit("submit");
  }
}
